module.exports = __webpack_public_path__ + "img/cancelar_icon.png";